import { withResolvedError } from '@wix/members-area-commons-ts';
import type { FlowAPI } from '@wix/yoshi-flow-editor';

import type {
  GetAllBadgesResponse,
  GetBlogPostsResponse,
  GetInitialDataResponse,
  GetMemberBadgesResponse,
  InitialDataRequest,
  LoadMoreBlogPostsOptions,
  MemberAbout,
  MembersAboutMiddlewareService as IMembersAboutMiddlewareService,
  UpdateAboutResponse,
} from '../types';

type ErrorHandler = FlowAPI['errorHandler'];
type HttpClient = FlowAPI['httpClient'];

type MembersAboutMiddlewareServiceOptions = {
  httpClient: HttpClient;
  errorHandler: ErrorHandler;
};

export class MembersAboutMiddlewareService
  implements IMembersAboutMiddlewareService
{
  private readonly httpClient: HttpClient;
  private readonly errorHandler: ErrorHandler;

  constructor({
    httpClient,
    errorHandler,
  }: MembersAboutMiddlewareServiceOptions) {
    this.httpClient = httpClient;
    this.errorHandler = errorHandler;
  }

  async getInitialData(options: InitialDataRequest) {
    const requestFn = () =>
      this.httpClient.get<GetInitialDataResponse>(
        `/_serverless/members-about-middleware/initial-data`,
        { params: options },
      );

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return data;
  }

  async updateAbout(about: MemberAbout) {
    const requestFn = () =>
      this.httpClient.post<UpdateAboutResponse>(
        `/_serverless/members-about-middleware/update-about`,
        { about },
      );

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return data;
  }

  async getAllBadges() {
    const requestFn = () =>
      this.httpClient.get<GetAllBadgesResponse>(
        `/_serverless/members-about-middleware/badges/all`,
      );

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return data;
  }

  async getMemberBadges(assignedBadgeIds: string[]) {
    const requestFn = () =>
      this.httpClient.post<GetMemberBadgesResponse>(
        `/_serverless/members-about-middleware/badges/member`,
        { assignedBadgeIds },
      );

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return data;
  }

  async getBlogPosts(options: LoadMoreBlogPostsOptions) {
    const requestFn = () =>
      this.httpClient.get<GetBlogPostsResponse>(
        `/_serverless/members-about-middleware/blog-posts`,
        { params: options },
      );

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return data;
  }
}
